import { graphql } from '@server/gql';

export const updateReviewMutation = graphql(/* GraphQL */ `
    mutation updateReview(
        $reviewId: String!
        $payload: ReviewUpdateDtoInput!
        $token: String!
    ) {
        updateReview(reviewId: $reviewId, payload: $payload, token: $token) {
            ... on ReviewResponseDto {
                acceptedAt
                comment
                createdAt
                id
                modifiedAt
                name
                productId
                score
                reviewStatus: status
                variantId
            }
            ...problemDetails
            ...genericResponse
        }
    }
`);
